import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const EMAIL = "stayflow.admin@gmail.com";
const ADDRESS = "163, Jyoti Nagar, Bongaon, Part - 3, Golaghat, Assam - 785621 (India)";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-ink text-white overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 max-w-sm text-white/60 leading-relaxed">
              The all-in-one hospitality operating system for independent
              homestays, hotels, resorts, restaurants, cafes, bars and lounges.
            </p>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              className="group mt-8 inline-flex items-center gap-2 text-white/90 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4 text-brand" aria-hidden="true" />
              <span className="border-b border-white/20 group-hover:border-white/60 transition-colors">{EMAIL}</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40">Navigate</p>
            <ul className="mt-5 space-y-3 text-white/70">
              <li><Link to="/home" data-testid="footer-home" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/pro" data-testid="footer-pro" className="hover:text-white transition-colors">Plans &amp; pricing</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/40">Registered Office</p>
            <div className="mt-5 flex gap-3 text-white/70 leading-relaxed">
              <MapPin className="w-5 h-5 shrink-0 text-brand mt-0.5" aria-hidden="true" />
              <address className="not-italic" data-testid="footer-address">{ADDRESS}</address>
            </div>
            <a
              href="https://www.stayflowapp.in"
              className="group mt-6 inline-flex items-center gap-1 text-white/60 hover:text-white transition-colors"
            >
              www.stayflowapp.in
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-24 border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/40 text-sm" data-testid="footer-copyright">© {year} StayFlow. StayFlow is a product of Abhijeet Phukan (Trading as StayFlow). All rights reserved.</p>
          <p className="text-white/40 text-sm font-mono" data-testid="footer-osm-credit">Place names © OpenStreetMap contributors</p>
        </div>
      </div>

      <div aria-hidden="true" className="select-none pointer-events-none">
        <div className="font-heading font-extrabold tracking-tighter text-white/[0.05] leading-none text-[24vw] text-center -mb-[3vw]">
          STAYFLOW
        </div>
      </div>
    </footer>
  );
};

export default Footer;
